/* eslint-disable react/jsx-key */
import isArray from 'lodash/isArray';
import styled, { css } from 'styled-components';
import moment from 'moment';

import React from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';

import AntdRate from 'antd/lib/rate';
import Descriptions from 'antd/lib/descriptions';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import tests from '../../helpers/tests';
import getFilterWithCol from '../../helpers/getFilterWithCol';

const OrderDescription = styled(Descriptions)`
  .ant-descriptions-title {
    font-size: 22px;
  }
  .ant-descriptions-item {
    display: flex;
  }
  .ant-list-item {
    border-bottom: 0px;
  }
`;

const OrderDescriptionSectionSeparator = styled.div`
  height: 20px;
`;

const Review = styled.div`

`;

const Rate = styled(AntdRate)`
  color: ${({ theme }) => theme.less.primaryColor};

  ${({ disabled }) => disabled && css`
    .ant-rate-star > div:hover, .ant-rate-star > div:focus {
      transform: none;
    }
  `}
`;

export const fieldReview = ['FieldReact', {
  label: null,
  renderContent: props => {
    const isAdmin = props.viewer?.role === 'ADMIN';
    return ([
      ['Details', [
        ['Customer', (
          <Link to={`/customers/${props.data.customer._id}`}>
            {props.data.customer.name}
          </Link>
        )],
        ['Order', (
          <Link to={`/orders/${props.data.order}`}>
            {props.data.order}
          </Link>
        )],
        (
          isAdmin
          ? ['Store', (
            <Link to={`/stores/${props.data.store._id}`}>
              {props.data.store.name}
            </Link>
          )]
          : null
        ),
        ['Product', (
          <Link to={`/products/${props.data.product}`}>
            {props.data.productName}
          </Link>
        )],
        ['Variation', (
            props.data.variationName
        )],
        ['Approved', (
          props.data.approved
          ? <CheckOutlined />
          : <CloseOutlined style={{ opacity: 0.2 }} />
        )],
        ['', <Rate value={props.data.rating} disabled />],
        ['Review', <Review>{props.data.message || '-'}</Review>],
      ]],
    ]
    .filter(section => section !== null)
    .reduce(
      // eslint-disable-next-line no-unused-vars
      (sections, section, index, initialSectionsArray) => {
        if (section) {
          sections.push(<OrderDescriptionSectionSeparator key="separator" />);
          sections.push(
            <OrderDescription
              key={section[0]}
              title={section[0]}
              column={1}
            >
              {
                isArray(section[1])
                ? section[1].reduce(
                    (items, item) => {
                      if (item) {
                        items.push(
                          <Descriptions.Item key={item[0]} label={item[0]}>
                            {item[1]}
                          </Descriptions.Item>
                        );
                      }
                      return items;
                    },
                    [],
                  )
                : section[1]
              }
            </OrderDescription>
          );
        }
        return sections;
      },
      [],
    ));
  },
}];

export const ALL = [
  fieldReview,
];

export const EDIT = [];

// Create fields for admin
export const fieldStore = getFilterWithCol(['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select store',
  label: 'Store',
  url: '/stores/list',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [tests.activityIsNotCreate],
  virtual: [tests.activityIsNotCreate],
  handleChange: (value, props) => {
    if (value !== props.value) {
      props.form.setFieldsValue({
        product: undefined,
      });
    }
  },
}], 24);

export const fieldProduct = getFilterWithCol(['FieldConnectionSelect', {
  name: 'product',
  placeholder: 'Select product',
  label: 'Product',
  url: '/products',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [
    tests.activityIsNotCreate,
    ['condition.testFieldValue', 'store', '==', undefined],
  ],
  getExtraQueryConditions: (props) => {
    const store = props.form?.getFieldValue?.('store');
    return store ? [{ store }] : [];
  },
}], 24);

export const fieldCustomer = getFilterWithCol(['FieldConnectionSelect', {
  name: 'customer',
  placeholder: 'Select customer',
  label: 'Customer',
  url: '/customers',
  searchPaths: ['name', 'email'],
  rules: [['validation.isRequired']],
  disabled: [tests.activityIsNotCreate],
}], 24);

export const fieldRating = getFilterWithCol(['FieldRadio', {
  name: 'rating',
  label: 'Rating',
  rules: [['validation.isRequired']],
  initialValue: 5,
  block: true,
  choices: [
    { label: '5 ★', value: 5 },
    { label: '4 ★', value: 4 },
    { label: '3 ★', value: 3 },
    { label: '2 ★', value: 2 },
    { label: '1 ★', value: 1 },
  ],
}], 12);

export const fieldApproved = getFilterWithCol(['FieldRadio', {
  name: 'approved',
  label: 'Approved',
  initialValue: true,
  block: true,
  choices: [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ],
}], 12);

export const fieldMessage = getFilterWithCol(['FieldTextArea', {
  name: 'message',
  label: 'Review Comment',
  placeholder: 'Enter review comment (optional)',
  autoSize: { minRows: 3 },
}], 24);

export const fieldCreatedAt = getFilterWithCol(['FieldDatePicker', {
  name: 'createdAt',
  label: 'Review Date',
  placeholder: 'Select date (optional, defaults to now)',
  prepareValueForInput: value => (value ? moment(value) : undefined),
}], 24);

export const CREATE = [
  fieldStore,
  fieldProduct,
  fieldCustomer,
  fieldRating,
  fieldApproved,
  fieldMessage,
  fieldCreatedAt,
];
